import React, { HTMLAttributes, useCallback, useRef, useState } from "react";
import { observer } from "mobx-react-lite";
import cx from "classnames";
import { Hooks } from "@xt/xtbase";
//import store from "store";

import styles from "./index.module.less";
import verifyLogo from "@/assets/images/home/logo2.png";
import { useEffect } from "react";
import { get_verifyChannel } from "@/api/xt-app";
import SvgIcon from "@xt/SvgIcon";
import VerifyDialog from "./verifyDialog";
const { useTranslation } = Hooks;
export interface VerifyDataProps {
  keyWords?: string;
  officialChannel?: boolean;
  channel?: string;
  channelName?: string;
}
interface Props extends HTMLAttributes<HTMLDivElement> {
  attr?: any;
}
const Verify: React.FC<Props> = ({ className }) => {
  const t = useTranslation();
  //const {isLogin} = store.user;
  const [isEmpty, setIsEmpty] = useState(false);
  const [isFocus, setIsFocus] = useState(false);
  const [keyWords, setKeyWords] = useState("");
  const [visible, setVisible] = useState(false);

  const [verifyData, setVerifyData] = useState<VerifyDataProps>({});
  useEffect(() => {
    setIsEmpty(!keyWords);
  }, [keyWords]);

  const onSearchBtn = (e: any, type?: string) => {
    if ((type === "keyboard" && e.code !== "Enter") || isEmpty) return;
    get_verifyChannel({ params: { channel: keyWords } }).then((res) => {
      res.keyWords = keyWords;
      setVerifyData(res);
      setVisible(true);
    });
  };
  const handleClose = () => {
    setVisible(false);
  };
  return (
    <div className={cx(styles["verify-container"], className)}>
      <header>
        <img src={verifyLogo} />
        <div></div>
        <span>{t("verify.verifyChannal")}</span>
      </header>
      <article>
        <div className={cx(styles["search-pane"])}>
          <input
            className={cx(isEmpty && isFocus && styles["input-empty"])}
            value={keyWords}
            onInput={(e) => {
              setKeyWords((e.target as HTMLInputElement).value);
            }}
            placeholder={t("verify.verifyInputTip")}
            onKeyUp={(e) => {
              onSearchBtn(e, "keyboard");
            }}
            onFocus={() => setIsFocus(true)}
            onBlur={() => setIsFocus(false)}
            maxLength={100}
          />
          <div className={cx(styles["p-btn"])} onClick={onSearchBtn}>
            <SvgIcon icon="search" style={{ color: "white", fontSize: "23px" }}></SvgIcon>
          </div>
        </div>
      </article>
      <footer>
        <p>{t("verify.verifyTip")}</p>
      </footer>
      <VerifyDialog verifyData={verifyData} visible={visible} onCloseModal={handleClose} />
    </div>
  );
};
export default observer(Verify);
